module.exports = __webpack_public_path__ + "img/zizhi.91c7b96a.png";